
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.12 17.964c0-1.24.07-2.48.11-3.72 0-.39-.1-1.57-.7-1.57H38.3a9.5 9.5 0 001-5.38c0-.27-.21-1.22-.67-1.15-3.5.48-5.69 3.28-6.51 6.53h-8.57l-1-7.64c-.26-2.11-1.51-.56-1.33.84.28 2.27.56 4.53.85 6.8h-2.38c-.6 0-.7 1.21-.69 1.57l.13 4.33a3.56 3.56 0 000 1.26l.16 5.08c.05 1.8-.06 3.69.16 5.49.19 1.61 1.06 2.41 1.41 4.13.01.148.034.296.07.44.53 3.15.1 6.83.18 10 .08 3.17.15 6.37.23 9.55 0 .39.08 1.58.69 1.58h15.08c.61 0 .69-1.21.7-1.58l.48-19.76c.15-1.42 1.25-3.14 1.43-4.73.18-1.59.1-3.44.15-5.13.074-2.18.137-4.36.19-6.54.03-.132.05-.266.06-.4zm-1.33-2.14v.84c-2.49 1-5.77.52-8.28.17a23.12 23.12 0 00-10 .59c0-.54 0-1.07-.05-1.6h18.33zm-1-6.35a6.48 6.48 0 01-2.42 3.18h-1.45a6.131 6.131 0 013.89-3.18h-.02zm-1.31 43.49h-6.19v-15.91c-.09-.71-.09-1.43 0-2.14.69-2.13 5.69-5.43 6.64-.42l-.45 18.47zm-7.57-17.14v17.14h-6.19c-.11-6.2 0-12.48-.47-18.64v-.1c.17-3.07 6.48-3.07 6.65 0v.42c.04.41.03.79.03 1.18h-.02zm9.43-5.42s-.16-.61-.84.69a1.332 1.332 0 00-.09.21c-1.26-2.23-3.63-3.62-6.35-1.74a4.22 4.22 0 00-1.49 1.79 4.34 4.34 0 00-4-2.6 4.25 4.25 0 00-3.91 2.45c-.29-.45-.93-1.31-.91-.93a25.305 25.305 0 010-4.43c-.05-1.77-.11-3.53-.16-5.29 4.44-1.28 8-.57 12.51-.28 1.872.205 3.766.073 5.59-.39-.05 1.83-.1 3.66-.16 5.49-.06 1.45.29 3.68-.17 5.03h-.02z"}})])
          )
        }
      }
    